import { j as n } from "./jsx-runtime-3tyXYecC.mjs";
import { useMemo as a } from "react";
import { S as u, a as D, b as c, c as m, D as d } from "./date-picker-provider.domain-CocKbrk9.mjs";
import { D as E } from "./date-picker-utils-provider-CwC1AjFc.mjs";
function f({
  children: i,
  formatType: e = "MM/dd/yyyy",
  locale: t = "en-us"
}) {
  const r = a(() => u.includes(t) ? t : D, [t]), s = a(() => c.includes(e) ? e : m, [e]), o = a(
    () => ({
      formatType: s,
      locale: r,
      utils: new E({ formats: { fullDate: s, isoDate: "yyyy-MM-dd" }, locale: r })
    }),
    [s, r]
  );
  return /* @__PURE__ */ n.jsx(d.Provider, { value: o, children: i });
}
export {
  f as D
};
//# sourceMappingURL=date-picker-provider-DNzBU4Fz.mjs.map
